import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert } from 'react-bootstrap'
import styled from 'styled-components'
import OverlayRight from '../../Page/logix2020/OverlayRight'
import OverlayContainer from '../../Page/logix2020/OverlayContainer'
import LanguageForm from '../../Forms/LanguageForm'
import LanguageNameInput from '../../Forms/LanguageNameInput'
import { ButtonWithLoadingState } from '../../Buttons'
import { useActivitiesState } from '../../../stores/Configuration/ActivitiesProvider'

const StyledDiv = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 0 1rem;
  box-sizing: border-box;
  overflow-x: hidden;
  @media (max-width: 768px) {
    button {
      width: 100% !important;
      display: block;
    }
  }
  .alert {
    margin-top: 1.5rem;
  }

  input,
  .form-control {
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .language-item,
  .tag-item {
    white-space: normal;
    word-break: break-word;
  }

  .overlay-content {
    max-width: 100%;
    width: 100%;
  }

  @media (min-width: 768px) {
    max-width: 600px;
  }
`

const ActivityGeneralForm = ({ activityId }) => {
  const { t } = useTranslation()
  const {
    successStates,
    errorStates,
    setActivity,
    activity,
    loadingStates,
    postActivity,
    patchActivity,
    setErrorStates,
    setSuccessStates,
  } = useActivitiesState()
  const [overlayVisible, setOverlayVisible] = useState(false)

  const handleCloseOverlay = () => {
    setOverlayVisible(false)
  }

  const updateNames = (translations) => {
    setErrorStates({})
    setSuccessStates({})
    setActivity((prev) => ({
      ...prev,
      name: {
        values: translations,
      },
    }))
  }

  useEffect(() => {
    if (!successStates.saveActivity) return

    const timer = setTimeout(() => {
      setSuccessStates((prev) => ({
        ...prev,
        saveActivity: false,
      }))
    }, 3000)

    return () => clearTimeout(timer)
  }, [successStates.saveActivity, setSuccessStates])

  const handleSubmit = () => {
    activityId ? patchActivity(activityId) : postActivity()
  }
  const nameError = errorStates.saveActivity?.value || null
  return (
    <StyledDiv>
      <LanguageNameInput
        openLanguageModal={() => setOverlayVisible(true)}
        languageArray={activity.name.values}
        onChange={updateNames}
        label={t('name')}
        isInvalid={!!nameError}
      />
      <ButtonWithLoadingState
        buttonText={t('saveButton')}
        isLoading={loadingStates.saveActivity}
        onClick={handleSubmit}
      />
      <OverlayContainer>
        <OverlayRight visible={overlayVisible} onClose={handleCloseOverlay}>
          <LanguageForm
            languageTitle={t('activities:activity')}
            handleCloseOverlay={handleCloseOverlay}
            languageArray={activity.name.values}
            onChange={updateNames}
          />
        </OverlayRight>
      </OverlayContainer>
      {successStates.saveActivity && (
        <Alert variant='success' className='my-2'>
          {t('registrationBox:savingSuccess')}
        </Alert>
      )}
      {errorStates.saveActivity && (
        <Alert variant='danger'>{errorStates.saveActivity.value}</Alert>
      )}
    </StyledDiv>
  )
}

export default ActivityGeneralForm
